import { useQuery } from '@tanstack/react-query';
import { getApplications } from 'Services/CustomerProfile/applications';

const useCustomerLendingApplication = () => useQuery(
  ['SERVICING_BFF', 'GET_APPLICATIONS'],
  getApplications,
);

export default useCustomerLendingApplication;
